// import React, { useState } from 'react'
// import * as api from '../utils/api/apiClient'
// import { toast } from 'react-toastify'

// const EmployeeForm = ({ onClose, onSuccess }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone_number: '',
//     aadhaar: '',
//     work_id: '',
//     pan: '',
//     address: '',
//   })
//   const [errors, setErrors] = useState({})

//   const handleChange = (e) => {
//     const { name, value } = e.target
//     setFormData((prev) => ({ ...prev, [name]: value }))
//     setErrors((prev) => ({ ...prev, [name]: '' }))
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     try {
//       const res = await api.addEmployee(formData)
//       toast.success('Employee added successfully')
//     } catch (error) {
//       if (error?.response?.data?.message) {
//         toast.error(error?.response?.data?.message)
//       }
//     } finally {
//       onSuccess()
//       onClose()
//     }
//   }

//   return (
//     <div className='max-w-2xl mx-auto p-6 border-2 rounded-lg shadow-lg'>
//       <h2 className='text-3xl font-extrabold text-center text-gray-800 mb-6'>
//         Employee Registration
//       </h2>
//       <form onSubmit={handleSubmit} className='space-y-6'>
//         {/* Name Section */}
//         <div>
//           <label
//             htmlFor='name'
//             className='block text-sm font-semibold text-gray-700'
//           >
//             Name
//           </label>
//           <input
//             type='text'
//             id='name'
//             name='name'
//             value={formData.name}
//             onChange={handleChange}
//             className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-link focus:border-link p-2'
//             placeholder='Enter full name'
//           />
//           {errors.name && (
//             <p className='text-red-500 text-sm mt-1'>{errors.name}</p>
//           )}
//         </div>

//         {/* Email */}
//         <div>
//           <label
//             htmlFor='email'
//             className='block text-sm font-semibold text-gray-700'
//           >
//             Email
//           </label>
//           <input
//             type='email'
//             id='email'
//             name='email'
//             value={formData.email}
//             onChange={handleChange}
//             className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-link focus:border-link p-2'
//             placeholder='Enter email address'
//           />
//           {errors.email && (
//             <p className='text-red-500 text-sm mt-1'>{errors.email}</p>
//           )}
//         </div>

//         {/* Employee ID */}
//         <div>
//           <label
//             htmlFor='employeeId'
//             className='block text-sm font-semibold text-gray-700'
//           >
//             Employee ID
//           </label>
//           <input
//             type='text'
//             id='work_id'
//             name='work_id'
//             value={formData.work_id}
//             onChange={handleChange}
//             className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-link focus:border-link p-2'
//             placeholder='Enter employee ID'
//           />
//           {/* {errors.employeeId && (
//             <p className='text-red-500 text-sm mt-1'>{errors.employeeId}</p>
//           )} */}
//         </div>
//         {/* Contact Number */}
//         <div>
//           <label
//             htmlFor='phone_number'
//             className='block text-sm font-semibold text-gray-700'
//           >
//             Phone Number
//           </label>
//           <input
//             type='text'
//             id='phone_number'
//             name='phone_number'
//             value={formData.phone_number}
//             onChange={handleChange}
//             className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-link focus:border-link p-2'
//             placeholder='Enter employee ID'
//           />
//           {/* {errors.employeeId && (
//             <p className='text-red-500 text-sm mt-1'>{errors.employeeId}</p>
//           )} */}
//         </div>
//         {/* Aadhaar */}
//         <div>
//           <label
//             htmlFor='aadhaar'
//             className='block text-sm font-semibold text-gray-700'
//           >
//             Aadhaar Number
//           </label>
//           <input
//             type='text'
//             id='aadhaar'
//             name='aadhaar'
//             value={formData.aadhaar}
//             onChange={handleChange}
//             className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-link focus:border-link p-2'
//             placeholder='Enter Aadhaar number'
//             maxLength='12'
//           />
//           {errors.aadhaar && (
//             <p className='text-red-500 text-sm mt-1'>{errors.aadhaar}</p>
//           )}
//         </div>

//         {/* PAN */}
//         <div>
//           <label
//             htmlFor='pan'
//             className='block text-sm font-semibold text-gray-700'
//           >
//             PAN Number
//           </label>
//           <input
//             type='text'
//             id='pan'
//             name='pan'
//             value={formData.pan}
//             onChange={handleChange}
//             className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-link focus:border-link p-2'
//             placeholder='Enter PAN number'
//             maxLength='10'
//           />
//           {errors.pan && (
//             <p className='text-red-500 text-sm mt-1'>{errors.pan}</p>
//           )}
//         </div>
//         {/* Adress */}
//         <div>
//           <label
//             htmlFor='employeeId'
//             className='block text-sm font-semibold text-gray-700'
//           >
//             Address
//           </label>
//           <textarea
//             type='text'
//             id='address'
//             name='address'
//             value={formData.address}
//             onChange={handleChange}
//             className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-link focus:border-link p-2'
//             placeholder='Enter your  address'
//           />
//           {/* {errors.employeeId && (
//             <p className='text-red-500 text-sm mt-1'>{errors.employeeId}</p>
//           )} */}
//         </div>

//         {/* Submit Button */}
//         <div>
//           <button
//             type='submit'
//             className='w-full py-3 px-4 bg-link text-white font-bold rounded-md shadow-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 transition duration-200'
//           >
//             Register
//           </button>
//         </div>
//       </form>
//     </div>
//   )
// }

// export default EmployeeForm

import React, { useState } from 'react'
import * as api from '../utils/api/apiClient'
import { toast } from 'react-toastify'

const EmployeeForm = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone_number: '',
    aadhaar: '',
    work_id: '',
    pan: '',
    address: '',
  })
  const [errors, setErrors] = useState({})

  const validate = () => {
    const newErrors = {}
    if (!formData.name.trim()) newErrors.name = 'Name is required'
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid email address'
    }
    if (!formData.phone_number.trim()) {
      newErrors.phone_number = 'Phone number is required'
    } else if (!/^\d{10}$/.test(formData.phone_number)) {
      newErrors.phone_number = 'Phone number must be 10 digits'
    }
    if (!formData.aadhaar.trim()) {
      newErrors.aadhaar = 'Aadhaar number is required'
    } else if (!/^\d{12}$/.test(formData.aadhaar)) {
      newErrors.aadhaar = 'Aadhaar number must be 12 digits'
    }
    if (!formData.pan.trim()) {
      newErrors.pan = 'PAN number is required'
    } else if (!/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.pan)) {
      newErrors.pan = 'Invalid PAN number format'
    }
    if (!formData.address.trim()) newErrors.address = 'Address is required'

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    setErrors((prev) => ({ ...prev, [name]: '' }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) return
    try {
      const res = await api.addEmployee(formData)
      toast.success('Employee added successfully')
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    } finally {
      onSuccess()
      onClose()
    }
  }

  return (
    <div className='max-w-2xl mx-auto p-6 border-2 rounded-lg shadow-lg bg-cream'>
      <h2 className='text-3xl font-extrabold text-center text-brown mb-6'>
        Employee Registration
      </h2>
      <form onSubmit={handleSubmit} className='space-y-6'>
        {/* Name Section */}
        <div>
          <label
            htmlFor='name'
            className='block text-sm font-semibold text-brown'
          >
            Name
          </label>
          <input
            type='text'
            id='name'
            name='name'
            value={formData.name}
            onChange={handleChange}
            className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-gold focus:border-gold p-2 bg-beige'
            placeholder='Enter full name'
          />
          {errors.name && (
            <p className='text-error text-sm mt-1'>{errors.name}</p>
          )}
        </div>

        {/* Email */}
        <div>
          <label
            htmlFor='email'
            className='block text-sm font-semibold text-brown'
          >
            Email
          </label>
          <input
            type='email'
            id='email'
            name='email'
            value={formData.email}
            onChange={handleChange}
            className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-gold focus:border-gold p-2 bg-beige'
            placeholder='Enter email address'
          />
          {errors.email && (
            <p className='text-error text-sm mt-1'>{errors.email}</p>
          )}
        </div>

        {/* Employee ID */}
        <div>
          <label
            htmlFor='work_id'
            className='block text-sm font-semibold text-brown'
          >
            Employee ID
          </label>
          <input
            type='text'
            id='work_id'
            name='work_id'
            value={formData.work_id}
            onChange={handleChange}
            className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-gold focus:border-gold p-2 bg-beige'
            placeholder='Enter employee ID'
          />
        </div>

        {/* Contact Number */}
        <div>
          <label
            htmlFor='phone_number'
            className='block text-sm font-semibold text-brown'
          >
            Phone Number
          </label>
          <input
            type='text'
            id='phone_number'
            name='phone_number'
            value={formData.phone_number}
            onChange={handleChange}
            className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-gold focus:border-gold p-2 bg-beige'
            placeholder='Enter phone number'
          />
          {errors.phone_number && (
            <p className='text-error text-sm mt-1'>{errors.phone_number}</p>
          )}
        </div>

        {/* Aadhaar */}
        <div>
          <label
            htmlFor='aadhaar'
            className='block text-sm font-semibold text-brown'
          >
            Aadhaar Number
          </label>
          <input
            type='text'
            id='aadhaar'
            name='aadhaar'
            value={formData.aadhaar}
            onChange={handleChange}
            className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-gold focus:border-gold p-2 bg-beige'
            placeholder='Enter Aadhaar number'
            maxLength='12'
          />
          {errors.aadhaar && (
            <p className='text-error text-sm mt-1'>{errors.aadhaar}</p>
          )}
        </div>

        {/* PAN */}
        <div>
          <label
            htmlFor='pan'
            className='block text-sm font-semibold text-brown'
          >
            PAN Number
          </label>
          <input
            type='text'
            id='pan'
            name='pan'
            value={formData.pan}
            onChange={handleChange}
            className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-gold focus:border-gold p-2 bg-beige'
            placeholder='Enter PAN number'
            maxLength='10'
          />
          {errors.pan && (
            <p className='text-error text-sm mt-1'>{errors.pan}</p>
          )}
        </div>

        {/* Address */}
        <div>
          <label
            htmlFor='address'
            className='block text-sm font-semibold text-brown'
          >
            Address
          </label>
          <textarea
            id='address'
            name='address'
            value={formData.address}
            onChange={handleChange}
            className='mt-1 block w-full rounded-md border-2 border-light_gray shadow-sm focus:ring-gold focus:border-gold p-2 bg-beige'
            placeholder='Enter your address'
          />
          {errors.address && (
            <p className='text-error text-sm mt-1'>{errors.address}</p>
          )}
        </div>

        {/* Submit Button */}
        <div>
          <button
            type='submit'
            className='w-full py-3 px-4 bg-tan text-white font-bold rounded-md shadow-lg hover:bg-gold focus:ring-2 focus:ring-terracotta transition duration-200'
          >
            Register
          </button>
        </div>
      </form>
    </div>
  )
}

export default EmployeeForm
